import * as React from 'react';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Card, CardContent, Typography } from '@mui/material';

import { BLACK } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

const NoContractCard = () => (
  <Card
    sx={{
      border: `1px solid ${BLACK[40]}`,
      borderRadius: '16px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    }}
  >
    <CardContent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '24px', fontFamily: PRIMARY_FONT[700], marginBottom: '8px' }}>
        {LanguageConverterV2('userDetail.workerContracts.emptyCardTitle')}
      </Typography>
      <Typography sx={{ fontSize: '16px', fontFamily: PRIMARY_FONT[300], color: BLACK[70] }}>
        {LanguageConverterV2('userDetail.workerContracts.emptyCardDescription')}
      </Typography>
    </CardContent>
  </Card>
);

export default NoContractCard;
